<template>
  <div class="message">
    <img class="avatar" :src="message.display_avatar">
    <div class="right-column">
      <time>{{ formatTime(message.created_at) }}</time>
      <div class="name">{{ message.display_name }}</div>
      <div class="message-content">{{ message.content }}</div>
    </div>
  </div>
</template>



<script>
export default {
  props: ['message'],
  data() {
    return {
    };
  },
  created() {},

  methods: {
    formatTime(time) {
      return moment(time).locale('zh-TW').calendar();
    }
  }

}
</script>


// WEBPACK FOOTER //
// app/javascript/packs/messenger/message.vue